export const ACCOUNT_TYPES = [
  { value: "GROUP", label: "GRUPO" },
  { value: "ANALYTIC", label: "ANALITICA" },
];
